import { useCallback } from "react"

import { useDropzone } from "react-dropzone"

import { acceptedFileTypesWithoutImages } from "@/app/pages/modules/ai-explorer-constants"

import { useAIParserSession } from "./use-ai-parser-session"
import { useUploadDocumentsMutation } from "./use-upload-documents-mutation"

export function useUploadZone() {
  const { currentSessionId } = useAIParserSession()
  const uploadDocumentsMutation = useUploadDocumentsMutation()

  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      uploadDocumentsMutation.mutate({
        sessionId: currentSessionId,
        files: acceptedFiles,
      })
    },
    [currentSessionId, uploadDocumentsMutation.mutate]
  )

  const dropzoneProps = useDropzone({
    onDrop,
    accept: acceptedFileTypesWithoutImages,
    multiple: true,
  })

  return {
    dropzoneProps,
    isUploading: uploadDocumentsMutation.isPending,
  }
}
